/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    Container, Stack, TextField, Box, TableBody, TableCell, Grid, Tooltip, IconButton, TableHead, TableRow, Table
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import services from '../Service';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@mui/material/TableContainer';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import SearchNotFound from '../../../SearchNotFound';
import { LoadingComponent } from 'src/pages/pageLoader';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import { Autocomplete } from '@mui/material';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';

var screenCode = 'FDCFCCOUTBOUNDINVOICE';

export default function ViewFDCFCCOutboundInvoice(props) {

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: 'unset',
            },
        },
    });
    const classes = useStyles();
    const componentRef = useRef([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [groupList, setGroupList] = useState([]);
    const [customerTypesList, setCustomerTypesList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [vehicle, setVehicle] = useState([]);
    const [gtnNumber, setGtnNumber] = useState([]);
    const [goodDetails, setGoodDetails] = useState([]);
    const [selectedFactory, setSelectedFactory] = useState(null);
    const [IsFactoryClear, setIsFactoryClear] = useState(false);


    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        submitButtonName: 'Generate',
        pageheadername: 'FDC/FCC Outbound Invoice'
    });
    const [date, setDate] = useState(new Date());

    const [formData, setFormData] = useState({
        groupID: 0,
        invoiceType: 1,
        customerTypeID: 0,
        operationEntityID: 0,
        vehicleID: 0,
        gtnNumber: ''
    });

    const goodsReceivedNoteSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        invoiceType: Yup.number().min(1, 'Please Select Invoice Type').required('Invoice Type is required'),
        customerTypeID: formData.invoiceType == 2 ? Yup.number().min(1, 'Please Select Customer Type').required('Customer Type is required') : Yup.number().notRequired(),
        operationEntityID: Yup.number().min(1)
            .min(1, formData.invoiceType == 1 ? 'Please Select Fresh Collection Center' : 'Please Select Outlet')
            .required(formData.invoiceType == 1 ? 'Fresh Collection Center is required' : 'Outlet is required'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            invoiceType: formData.invoiceType,
            customerTypeID: formData.customerTypeID,
            operationEntityID: formData.operationEntityID,
            vehicleID: formData.vehicleID,
            gtnNumber: formData.gtnNumber
        },

        validationSchema: goodsReceivedNoteSchema,
        onSubmit: (values) => {
            trackPromise(SearchData());
        }
    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
        setGoodDetails([]);
        setSelectedFactory(null);
        setIsFactoryClear(!IsFactoryClear);
        setFormData((prevState) => ({
            ...prevState,
            invoiceType: formik.values.invoiceType,
        }));
    }, [formik.values.groupID, formik.values.invoiceType, formik.values.customerTypeID]);


    useEffect(() => {
        setGoodDetails([])
        trackPromise(GetVehicleForOutboundInvoice())
        setFormData((prevState) => ({
            ...prevState,
            vehicleID: 0,
            gtnNumber: ''
        }));
    }, [formik.values.invoiceType, formik.values.operationEntityID, date]);



    useEffect(() => {
        setGoodDetails([])
        trackPromise(GetGTNnumberForOutboundInvoice())
        setFormData((prevState) => ({
            ...prevState,
            gtnNumber: ''
        }));
    }, [formik.values.invoiceType, formik.values.operationEntityID, formik.values.vehicleID, date]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find((p) => p.permissionCode == 'VIEWFDCFCCOUTBOUNDINVOICE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        });
        trackPromise(GetAllGroups(), GetAllCustomerTypes());
    }

    async function GetAllGroups() {
        var groupArray = [];
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
            for (let item of Object.entries(res)) {
                groupArray[item[1]["groupID"]] = item[1]["groupName"]
            }
        }
    }

    async function GetAllCustomerTypes() {
        var res = await services.GetAllCustomerTypes();
        if (res != null) {
            setCustomerTypesList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        setOperationEntityList([])
        if (formik.values.invoiceType == 1) {
            var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
            if (res != null) {
                const found = res.filter(x => x.factoryType == 2)
                setOperationEntityList(found);
            }
        }
        else if (formik.values.invoiceType == 2) {
            var res = await services.GetOutletsByCustomerTypeID(formik.values.groupID, formik.values.customerTypeID);
            if (res != null) {
                setOperationEntityList(res);
            }
        }
    }

    async function GetVehicleForOutboundInvoice() {
        var res = await services.GetVehicleForOutboundInvoice(formik.values.invoiceType, formik.values.operationEntityID, new Date(date).toISOString());
        if (res != null) {
            setVehicle(res);
        }
    }

    async function GetGTNnumberForOutboundInvoice() {
        var res = await services.GetGTNnumberForOutboundInvoice(formik.values.invoiceType, formik.values.operationEntityID,
            formik.values.vehicleID, new Date(date).toISOString());
        if (res != null) {
            setGtnNumber(res);
        }
    }

    async function SearchData() {
        let model = {
            invoiceType: formik.values.invoiceType,
            factoryID: formik.values.operationEntityID,
            vehicleID: formik.values.vehicleID,
            gtnNumber: formik.values.gtnNumber,
            date: new Date(date).toISOString()
        }
        const Result = await services.GetFDCFCCOutboundInvoiceDetails(model);
        setGoodDetails(Result)
    }

    function clearAll() {
        setValues((prevState) => ({
            ...prevState,
            customerTypeID: 0,
            operationEntityID: 0,
            vehicleID: 0,
            gtnNumber: ''
        }));
        setGoodDetails([]);
        setSelectedFactory(null);
        setIsFactoryClear(!IsFactoryClear);
    }

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.factoryName && option.factoryName.toLowerCase().includes(trimmedInput))
        ).filter(option => option.factoryName !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.factoryName.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });

        // Return exact matches if any, otherwise return non-exact matches
        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    function handleSearchDropdownChange(data, e) {
        setSelectedFactory(data);
        if (data === undefined || data === null) {
            setValues({
                ...values,
                operationEntityID: '0'
            });
            return;
        } else {
            var value = data.factoryID;
            setValues({
                ...values,
                operationEntityID: value,
            });
        }
    }

    var currentdate = new Date();
    var datetime = currentdate.getDate() + "/"
        + (currentdate.getMonth() + 1) + "/"
        + currentdate.getFullYear() + " "
        + currentdate.getHours() + ":"
        + currentdate.getMinutes() + ":"
        + currentdate.getSeconds();

    return (
        <>
            <LoadingComponent />
            <Page title="FDC/FCC Outbound Invoice |  FAPS">
                <Container>
                    <CommonPageHeader path="/dashboard" btname="Back" pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {groupList.map((option) => (
                                                <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Invoice Type *"
                                            value={formik.values.invoiceType}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('invoiceType')}
                                            error={Boolean(touched.invoiceType && errors.invoiceType)}
                                            helperText={touched.invoiceType && errors.invoiceType}

                                        >
                                            <MenuItem value={1}>FDC Inbound Invoice</MenuItem>
                                            <MenuItem value={2}>FDC Outbound Invoice</MenuItem>
                                        </TextField>
                                    </Grid>
                                    {formik.values.invoiceType == 2 ?
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Customer Type *"
                                                value={formik.values.customerTypeID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('customerTypeID')}
                                                error={Boolean(touched.customerTypeID && errors.customerTypeID)}
                                                helperText={touched.customerTypeID && errors.customerTypeID}
                                            >
                                                <MenuItem value={0}>Select Customer Type</MenuItem>
                                                {customerTypesList.map((option) => (
                                                    <MenuItem key={option.customerTypeID} value={option.customerTypeID}>
                                                        {option.customerTypeName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid> : null}
                                    <Grid item md={4} xs={12}>
                                        <Autocomplete
                                            fullWidth
                                            key={IsFactoryClear}
                                            clearOnEscape
                                            id="operationEntityID"
                                            options={operationEntityList}
                                            value={selectedFactory}
                                            filterOptions={filterOptions}
                                            getOptionLabel={(option) => `${option.factoryName}`}
                                            onChange={(e, value) => handleSearchDropdownChange(value, e)}
                                            renderOption={(props, option) => (
                                                <li {...props}>
                                                    {`${option.factoryName}`}
                                                </li>
                                            )}
                                            renderInput={(params) =>
                                                <TextField {...params}
                                                    variant="outlined"
                                                    name="operationEntityID"
                                                    label={formik.values.invoiceType == 1 ? "Fresh Collection Center *" : "Outlet *"}
                                                    size="small"
                                                    fullWidth
                                                    helperText={touched.operationEntityID && errors.operationEntityID}
                                                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                                />
                                            }
                                        />
                                    </Grid>
                                    {formik.values.invoiceType == 1 ?
                                        <Grid item md={4} xs={12}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label="Select Date *"
                                                    value={date}
                                                    onChange={(newValue) => {
                                                        setDate(newValue);
                                                    }}
                                                    maxDate={new Date()}
                                                    renderInput={(params) => <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('date')}
                                                        error={Boolean(touched.date && errors.date)}
                                                        helperText={touched.date && errors.date}

                                                        {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid> : null}
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    {formik.values.invoiceType == 2 ?
                                        <Grid item md={4} xs={12}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    label="Select Date"
                                                    value={date}
                                                    onChange={(newValue) => {
                                                        setDate(newValue);
                                                    }}

                                                    renderInput={(params) => <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('date')}
                                                        error={Boolean(touched.date && errors.date)}
                                                        helperText={touched.date && errors.date}

                                                        {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid> : null}
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Vehicle"
                                            value={formik.values.vehicleID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('vehicleID')}
                                        >
                                            <MenuItem value={0}>Select Vehicle</MenuItem>
                                            {vehicle.map((option) => (
                                                <MenuItem key={option.vehicleID} value={option.vehicleID}>
                                                    {option.vehicleNumber}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="GTN Number"
                                            value={formik.values.gtnNumber}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('gtnNumber')}
                                        >
                                            <MenuItem value={''}>Select GTN Number</MenuItem>
                                            {gtnNumber.map((option, i) => (
                                                <MenuItem key={i} value={option.gtnNumber}>
                                                    {option.gtnNumber}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    {formik.values.invoiceType == 1 ?
                                        <Grid item md={4} xs={12}>
                                        </Grid> : null}
                                    <Grid item md={4} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined" >
                                                Search
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                                <Divider variant="middle" />
                                {goodDetails.length > 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="center">
                                        <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                            <Paper className={classes.root}>
                                                <TableContainer component={Paper}>
                                                    <Table aria-label="collapsible table" size='small'>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>FCC</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>Vehicle Number</TableCell>
                                                                <TableCell align="left" style={{ fontWeight: 'bold' }}>Outbound No</TableCell>
                                                                <TableCell align="right" style={{ fontWeight: 'bold' }}>Total Crop</TableCell>
                                                                <TableCell align="right" style={{ fontWeight: 'bold' }}>Total Qty</TableCell>
                                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Download</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody >
                                                            {goodDetails.map((row, index) => {
                                                                componentRef.current[index] = componentRef.current[index]
                                                                return (
                                                                    <TableRow>
                                                                        <TableCell align="left" >{row.factoryName}</TableCell>
                                                                        <TableCell align="left" >{row.vehicleNumber}</TableCell>
                                                                        <TableCell align="left" >{row.gtnNumber}</TableCell>
                                                                        <TableCell align="right" >{row.cropCount}</TableCell>
                                                                        <TableCell align="right" >{parseFloat(row.totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2 })}</TableCell>
                                                                        <TableCell align="center" >
                                                                            <ReactToPrint
                                                                                documentTitle={"Goods Receive Note"}
                                                                                trigger={() =>
                                                                                    <IconButton aria-label="delete" type="submit">
                                                                                        <PictureAsPdfIcon />
                                                                                    </IconButton>
                                                                                }
                                                                                content={() => componentRef.current[index]}
                                                                            />
                                                                            <div hidden={true}>
                                                                                <CreatePDF
                                                                                    ref={(el) => (componentRef.current[index] = el)}
                                                                                    goodData={row}
                                                                                    goodDataDetails={row.details}
                                                                                    datetime={datetime}
                                                                                />
                                                                            </div>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Paper>
                                        </Card>
                                    </Stack> : <SearchNotFound searchQuery="FDC/FCC Outbound Invoice" />}
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}

